import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User completed signup',
  name: 'signed_up',
  params: [
    {
      description: 'Type of account created',
      name: 'account_type',
      required: true,
      type: 'enum',
      values: ['full', 'anonymous'],
    },
    {
      description: 'Authentication method used',
      name: 'auth_method',
      required: true,
      type: 'enum',
      values: ['email', 'google', 'apple', 'saml'],
    },
    {
      description: 'Context of signup',
      name: 'context',
      required: true,
      type: 'enum',
      values: ['fresh_signup', 'join_from_invite', 'share_link', 'canva'],
    },
    {
      description: 'User ID',
      name: 'id',
      required: true,
      type: 'string',
    },
    {
      description: 'User email',
      name: 'email',
      required: true,
      type: 'string',
    },
    {
      description: 'User first name',
      name: 'first_name',
      required: false,
      type: 'string',
    },
    {
      description: 'User last name',
      name: 'last_name',
      required: false,
      type: 'string',
    },
    {
      description: 'Workspace ID when joining existing workspace',
      name: 'workspace_id',
      required: false,
      type: 'string',
    },
    {
      description: 'Workspace name when joining existing workspace',
      name: 'workspace_name',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
